import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";

/**
 * Middleware component for handling value formatting and parsing logic
 * for number inputs used in care element configuration components.
 */
function NumberInput({
    value,
    onChange,
    dataCy,
    disabled,
    isInvalid
}: Readonly<{
    value: string | number;
    onChange: (value: number | null) => void;
    dataCy?: string;
    disabled?: boolean;
    isInvalid?: boolean;
}>): JSX.Element {
    const handleChange = (value: string): void => {
        if (value == "" || IsNullOrUndefined(value)) {
            onChange(null);
        }
        else {
            onChange(+value);
        }
    };

    const formatValue = (value: any): string => {
        if (value == "" || IsNullOrUndefined(value))
            return "";

        return value.toString();
    };

    return (
        <TextboxControl
            type="number"
            value={formatValue(value)}
            onChange={handleChange}
            dataCy={dataCy}
            disabled={disabled}
            className="form-control myle-control"
            valid={!isInvalid}
        />
    );
}

export { NumberInput };
